@if (selectedLogon$ | async; as logon) {
  @if (showStatusBar) {
    <pl-status-bar></pl-status-bar>
  }
  <div class="card__internal">
    <div class="form-fields">
      <div class="logon">
        <label for="logon">Logon</label>
        <span>
          {{ logon?.logon }}</span
          >
        </div>
        <div class="perfil">
          <label for="perfil">Perfil</label>
          <span>{{ getTranslatedProfile(logon) }}</span
            >
          </div>
        </div>
        <div class="form-fields">
          <div class="nome">
            <label for="nome">Nome</label>
            <span>{{ logon?.fullname ? logon?.fullname : '-' }}</span>
          </div>
        </div>
        <div class="form-fields">
          <div class="email">
            <label for="email">E-mail</label>
            <span>{{ logon?.alternativeEmail?.email ? logon?.alternativeEmail?.email : '-' }}</span>
          </div>
        </div>
        <div class="form-fields">
          <div class="cpf">
            @if (logon?.document?.documentCountry === 'BRA') {
              <label for="cpf">CPF</label>
            }
            @if (logon?.document?.documentCountry !== 'BRA') {
              <label for="rnm">RNM</label>
            }
            @if (logon?.document && logon?.document?.documentCountry === 'BRA') {
              <span>{{ logon?.document?.documentId | document }}</span>
            }
            @if (logon?.document && logon?.document?.documentCountry !== 'BRA') {
              <span>{{ logon?.document?.documentId }}</span>
            }
            @if (!logon?.document) {
              <span> - </span>
            }
          </div>
          <div class="celular">
            <label for="celular">Número de celular</label>
            @if (logon?.phone) {
              <span>{{ logon?.phone?.areaCode + '' + logon?.phone?.phoneNumber | phone:false }}</span>
            }
            @if (!logon?.phone) {
              <span> - </span>
            }
          </div>
        </div>
        @if (userIsBlocked(logon?.status)) {
          <div class="form-fields">
            <div class="blocking-description">
              <label for="blocking-description">Motivos do bloqueio</label>
              @for (blocks of logon?.blockageTypes; track blocks) {
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="none"
                    >
                    <path
                      fill="#E4002B"
                      d="M7 .344A6.642 6.642 0 0 0 .344 7 6.642 6.642 0 0 0 7 13.656 6.642 6.642 0 0 0 13.656 7 6.642 6.642 0 0 0 7 .344Zm2.875 9.531c-.281.25-.688.25-.938 0L7 7.937 5.062 9.876c-.25.25-.656.25-.937 0-.25-.281-.25-.688 0-.938L6.063 7 4.125 5.062c-.25-.25-.25-.656 0-.937.281-.25.688-.25.938 0L7 6.063l1.938-1.938c.25-.25.656-.25.937 0 .25.281.25.688 0 .938L7.937 7l1.938 1.938c.25.25.25.656 0 .937Z"
                      />
                  </svg>
                  <span class="blocking-description__text">{{ getTranslatedReason(blocks.description)}}{{getTranslatedJustification(blocks.reason)}}</span>
                </div>
              }
            </div>
          </div>
        }
        <div class="form-fields">
          <div class="criado-em">
            <label for="criado-em">Usuário criado em</label>
            <span>{{
              logon?.registrationAt
              ? (logon?.registrationAt | date : 'dd/MM/yyyy')
              : '-'
            }}</span>
          </div>
          <div class="criado-por">
            <label for="criado-por">Usuário criado por</label>
            <span>{{logon?.createdBy ? logon?.createdBy?.logon + ' - ' + logon?.createdBy?.fullname : '-'}}</span>
          </div>
        </div>
        <div class="form-fields">
          <div class="ultimo-acesso">
            <label for="ultimo-acesso">Último acesso</label>
            <span>{{
              logon?.lastAccessAt ? (logon?.lastAccessAt | date : 'dd/MM/yyyy') : '-'
            }}</span>
          </div>
          <div class="ultima-revisao">
            <label for="ultima-revisao">Última revisão de dados</label>
            <span>{{
              logon?.lastDataRevisionAt ? (logon?.lastDataRevisionAt | date : 'dd/MM/yyyy') : '-'
            }}</span>
          </div>
        </div>
        <div class="form-fields">
          <div class="ultimo-bloqueio">
            <label for="ultimo-bloqueio">Último bloqueio</label>
            <span>{{
              logon?.blockedAt ? (logon?.blockedAt | date : 'dd/MM/yyyy') : '-'
            }}</span>
          </div>
          <div class="edicao-dados">
            <div class="edicao-dados">
              <label for="edicao-dados">Última edição de dados cadastrais</label>
              <span>{{
                logon?.lastUpdateAt
                ? (logon?.lastUpdateAt | date : 'dd/MM/yyyy')
                : '-'
              }}</span>
            </div>
          </div>
        </div>
      </div>
    }
